<template>
    <div class="mid_scroll_content mainWallet-page">
        <loader v-if="pageLoader"></loader>
        <div class="row justify-content-between mt-4 mx-0">
            <div class="col-12">
                <div class="mainTitle mb-4 d-flex align-items-center justify-content-between mb-4">
                    <div class="titleBlock">
                        <h3>Wallet Overview</h3>
                        <p>A glimpse of your cryptocurrency wallets</p>
                    </div>
                    <change-account></change-account>
                </div>
            </div>
            <div class="col-12 col-md-5">
                <div class="d-flex align-items-center">
                    <div class="card-body card-shadow mr-4">
                        <p class="medium mb-5">Estimated Holding Value</p>


                        <h3 class="medium secondary">&#8383;{{formatPrice(totalBtcValue, true)}}</h3>
                    </div>
                    <div class="card-body card-shadow">
                        <p class="medium mb-5">Estimated Holding Value</p>
                        <h3 class="medium secondary">${{formatPrice(totalUsdValue)}}</h3>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 portfolioPage">
                <!-- <div class="d-flex align-items-center justify-content-between"><div class="circleChartBlock"><img src="../../../../static/website/images/fullChart.svg" alt="aim chart" title="aim chart"></div><ul class="valueChart d-flex flex-wrap justify-content-between"><li class="c2"><p class="d-flex align-items-center mb-0"><span class="dot"></span>BTC </p><p class="mb-0">35%</p></li><li class="ada"><p class="d-flex align-items-center mb-0"><span class="dot"></span>ADA </p><p class="mb-0">9.8%</p></li><li class="green"><p class="d-flex align-items-center mb-0"><span class="dot"></span>USDT </p><p class="mb-0">22%</p></li><li class="eth"><p class="d-flex align-items-center mb-0"><span class="dot"></span>ETH </p><p class="mb-0">12%</p></li><li class="textcolor"><p class="d-flex align-items-center mb-0"><span class="dot"></span>LTC </p><p class="mb-0">18%</p></li><li class="yellow"><p class="d-flex align-items-center mb-0"><span class="dot"></span>DOGE </p><p class="mb-0">3.2%</p></li></ul></div>-->
                <currencyChart style="height: 230px;" :currency_list="curencyUsdValList" :from="'portfolio'" />
            </div>
            <div class="col-12 mb-3 my-md-5">
                <div class="d-flex align-items-center justify-content-between mb-3">
                    <h3 class="semibold">My Wallets</h3>
                    <div class="d-flex align-items-center">
                        <div class="d-flex align-items-center mr-3">
                            <label class="toggleSwitch"> <input type="checkbox" v-model="hideZero" @change="page='1'" /> <span class="slider round"></span> </label>
                            <p class="mb-0 ml-3">Hide Zero Balance</p>
                        </div>
                        <div class="form-group position-relative includeIco searchTable mb-0">
                            <input type="text" placeholder="Search all Cryptos" name="legal_name" class="form-control small" v-model="searchCurrency" @keyup="page='1'" /> <span class="searchIco"><feather type="search" /></span>
                        </div>
                    </div>
                </div>
                <div class="myAssets border position-relative border-radius-15 mt-4">
                    <div class="marketData table-responsive">
                        <table class="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>Asset</th>
                                    <th>Current Holdings</th>
                                    <th>
                                        Reserved Fund
                                        <sup>
                                            <a class="hoverInfo" href="javascript:void(0)"><feather type="info" /></a>
                                        </sup>
                                    </th>
                                    <th>
                                        Holding Value
                                        <sup>
                                            <a class="hoverInfo" href="javascript:void(0)"><feather type="info" /></a>
                                        </sup>
                                    </th>
                                    <th>Average Price</th>
                                    <th>ROI</th>
                                    <th>Est. USD Value</th>
                                    <th>24h Change</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody v-if="!pageLoader && marginList.length > 0">
                                {{getPage}}
                                <tr v-for="(value, index) in marginList" v-if=" index >=(page - 1) * pageLimit && index < page * pageLimit ">
                                    <td>
                                        <span class="d-flex align-items-center">
                                            <span class="inTableIcon ml-0">
                                                <img
                                                    :src=" '../../../../static/website/images/crypto_logos/' + value.symbol.toLowerCase() + '.png' "
                                                    @error="handleImgErr($event)"
                                                    :alt="value.symbol"
                                                    v-if="isImage(value.symbol.toLowerCase())"
                                                />
                                                <span class="firstName" v-else>{{value.symbol.charAt(0)}}</span>
                                            </span>
                                            <div class="iqlName" v-if="$env_var.restricted_currencies.hasOwnProperty(value.symbol)">
                                                <p class="mb-0 themecolor medium">{{$env_var.restricted_currencies[value.symbol].currency_name }}</p>
                                                <p class="f-10 mb-0">{{value.symbol}}</p>
                                            </div>
                                            <div class="iqlName" v-else>
                                                <p class="mb-0 themecolor medium">{{value.symbol}}</p>
                                                <p class="f-10 mb-0">{{value.currency_name}}</p>
                                            </div>
                                            <!-- <div class="position-relative ml-3"><a @click.prevent="(currIndex==index)?(currIndex=-1):(currIndex=index)" class="more-horizontal" href="javascript:void(0)"><feather type="chevron-down"/></a><ul class="dropdown_menu small dropdown_menu-6 py-1" :class="[{'show':(currIndex==index)}]"><li class="border-bottom"><h6>Base Currency</h6></li><li><a href="javascript:void(0)"></a>BTC</li><li><a href="javascript:void(0)"></a>ETH</li><li><a href="javascript:void(0)"></a>USD</li><li><a href="javascript:void(0)"></a>EUR</li><li><a href="javascript:void(0)"></a>USDT</li></ul></div>-->
                                        </span>
                                    </td>
                                    <td>{{marginByCurrency[value.symbol] ? formatPrice(marginByCurrency[value.symbol].amount, true): "0"}}</td>
                                    <td>0</td>
                                    <td class="green">{{marginByCurrency[value.symbol] ? formatPrice( marginByCurrency[value.symbol].amount, true ) : "0"}}</td>
                                    <td>{{marginByCurrency[value.symbol] ? formatPrice( marginByCurrency[value.symbol].holdingPrice, true ) : "0"}}</td>
                                    <td>{{formatPrice(getROI(marginByCurrency[value.symbol]))}}%</td>
                                    <td><span v-if="marginByCurrency[value.symbol]">{{formatPrice( parseFloat( getConvertedValue( marginByCurrency[value.symbol], "USD" ) ) ) || "-"}}</span> <span v-else>-</span></td>
                                    <td>-</td>
                                    <td>
                                        <a @click.prevent=" actionIndex==index ? (actionIndex=-1) : (actionIndex=index) " href="javascript:void(0)" class="tableDropOption"><feather type="more-horizontal" /></a>
                                        <ul class="dropdown_menu small flexMenu dropdown_menu-6 py-1" :class="[{show: actionIndex==index}]">
                                            <li>
                                                <router-link :to="{name: 'smart_trading', params:{sendCurrency: value.symbol},}" v-if="value.amount && formatfloat(value.amount)"> <feather type="refresh-ccw" /> Trade </router-link>
                                                <a href="javascript:void(0)" class="disabled" v-else><feather type="refresh-ccw" /> Trade </a>
                                            </li>
                                            <li>
                                                <a
                                                    href="javascript:void(0)"
                                                    class="disabled"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="Please wait while we are verifying your document(s)"
                                                    v-if=" (parseInt(get_user.lead_type)==0 && parseInt(get_user.verified_status)==0 && value.keyType=='ERC20') || (parseInt(get_user.lead_type)==1 && parseInt(get_user.verified_status)==0) || !withDepoCurFilter.includes(value.symbol) "
                                                >
                                                    <feather type="download" /> Deposit
                                                </a>
                                                <router-link :to="{path: '/deposit-withdrawal', query:{deposit: value.symbol},}" v-else><feather type="download" /> Deposit </router-link>
                                            </li>
                                            <li v-if="parseInt(get_user.lead_type)==0">
                                                <span v-if="withDepoCurFilter.includes(value.symbol) && marginByCurrency[value.symbol] && formatfloat(marginByCurrency[value.symbol].amount) > 0">
                                                    <a
                                                        class="disabled hjmn"
                                                        href="javascript:void(0)"
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        :title="value.amount > 0 ? 'Please wait while we are verifying your document(s)' : 'No balances available'"
                                                        v-if="parseInt(get_user.verified_status)==0 && value.keyType=='ERC20'"
                                                    >
                                                        <feather type="briefcase" />Withdraw
                                                    </a>
                                                    <router-link :to="{path: '/deposit-withdrawal', query:{withdraw: value.symbol},}" :class="pageLoader ? 'disabled' : ''" v-else> <feather type="briefcase" />Withdraw </router-link>
                                                </span>
                                                <span v-else>
                                                    <a
                                                        class="disabled dv"
                                                        href="javascript:void(0)"
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        :title="value.amount > 0 ? 'Please wait while we are verifying your document(s)' : 'No balances available'"
                                                    >
                                                        <feather type="briefcase" />Withdraw
                                                    </a>
                                                </span>
                                            </li>
                                            <li v-else>
                                                <a
                                                    class="disabled"
                                                    href="javascript:void(0)"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    :title=" value.amount > 0 ? 'Please wait while we are verifying your document(s)' : 'No balances available' "
                                                    v-if=" parseInt(get_user.verified_status)==0 || formatfloat(value.amount)==0 "
                                                >
                                                    <feather type="briefcase" /> Withdraw
                                                </a>
                                                <router-link :to="{path: '/deposit-withdrawal', query:{withdraw: value.symbol},}" :class="pageLoader ? 'disabled' : ''" v-else> <feather type="briefcase" />Withdraw </router-link>
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                            </tbody>
                            <table-loader :pageloader_value="pageLoader" :type="'table'" :colspan="'9'" :listLength="marginList.length" v-else></table-loader>
                        </table>
                    </div>
                    <pagination :totalRecords="marginList.length" :limit="pageLimit" :pageNo="page" v-if="marginList.length > 0 && !pageLoader" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { tradingMixins } from "@/plugins/trading";
import { depositWithdrawalMixins } from "@/plugins/depositWithdrawal";
import deposit from "../deposit-withdrawal/popup_deposit";
import withdraw from "../deposit-withdrawal/popup_withdraw";
import math from "../../../../static/website/js/math.js";
import TwoFa from "../security/security";
import currencyChart from "../shared/chart/currencyChart";
import { Const } from "@/plugins/vue-provider-cache/const.mod";
export default {
  name: "Wallets",
  mixins: [tradingMixins, depositWithdrawalMixins],
  data() {
    return {
      baseCurrency: false,
      baseCurrency2: false,
      currencies: false,

      pageLoader: false,
      currIndex: -1,
      actionIndex: -1,
      notification_msg: "",
      notification_type: "",
      margin_list: {}, // currency with ammount available in account
      fev_list: [],
      Showfev: false,
      searchBy: "ALL",
      hideZero: false,
      searchCurrency: "",
      page: "1",
      pageLimit: "10",
      errImage: ["abc"],
      //deposit-module================
      currency_selected: "",
      get_method_id: "",
      raised_max_limit_msg: "",
      responseTransLimitData: {
        1: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
        2: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
        3: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
        4: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
        5: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
        6: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
        7: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
        8: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
        11: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
      },
      deposit_currency: "",
      deposit_currency_name: "",
      title: "No balances available",

      withdrawalItem: {},
      withdrawalOtp: false,
      curencyUsdValList: [],
    };
  },
  watch: {
    tradingAccount(value) {
      if (!parseInt(this.accountSelected)) {
        this.getCurrency(value);
      }
    },
    socialAccount(value) {
      if (parseInt(this.accountSelected) == 1) {
        this.getCurrency(value);
      }
    },
  },
  components: {
    appDeposit: deposit,
    appWithdraw: withdraw,
    currencyChart,
    // appTwofa : TwoFa
  },
  computed: {
    withDepoCurFilter(){
      return this.withDepoCurList.map(v=>v.symbol)
    },
    getPage() {
      if (
        Math.ceil(this.marginList.length / parseInt(this.pageLimit)) <
        parseInt(this.page)
      ) {
        this.page = parseInt(this.page) - 1;
      }
    },
    instruments() {
      try {
        this.$store.getters[Const.GET_HEARTBEATS]["priceFeed"];
        return this.$store.getters[Const.GET_PROVIDERS][
          "priceFeed"
        ].iCache.asKeysValueArrayAll();
      } catch (ex) {
        return [];
      }
    },
    totalUsdValue() {
      try {
        let amount = 0;
        for (const item in this.margin_list) {
          amount += parseFloat(
            this.getConvertedValue(this.margin_list[item], "USD")
          );
        }
        return amount.toFixed(3);
      } catch (e) {
        return "N/A";
      }
    },
    totalBtcValue() {
      try {

        let marginlist = {}

        marginlist.currency = "USD"
        marginlist.amount = this.totalUsdValue

        let amount = parseFloat(
            this.getConvertedValue(marginlist, "BTC")
        );
        // for (const item in this.margin_list) {
        //   amount += parseFloat(
        //     this.getConvertedValue(this.margin_list[item], "BTC")
        //   );
        // }
        return this.formatfloat(amount.toFixed(8));
      } catch (e) {
        return "N/A";
      }
    },
    marginByCurrency() {
      let stored = {};
      for (const key in this.margin_list) {
        if (parseFloat(this.margin_list[key].amount) > 0) {
          stored[this.margin_list[key].currency] = this.margin_list[key];
        }
      }
      return stored;
    },
    marginList() {
      let returnData = [],
        NotZero = [];
        console.log('this.$env_var.walletCurrencyList==>',this.$env_var.walletCurrencyList)
      returnData = Object.values(this.$env_var.walletCurrencyList).filter(
        (val) => !(val.symbol in this.marginByCurrency)
      );
      NotZero = Object.values(this.$env_var.walletCurrencyList).filter(
        (val) => val.symbol in this.marginByCurrency
      );
      returnData = NotZero.concat(returnData);
      if (this.hideZero) {
        if (this.searchCurrency != "") {
          let search = this.searchCurrency.toLowerCase();
          NotZero = NotZero.filter(
            (val) =>
              val.symbol.toLowerCase().includes(search) ||
              val.currency_name.toLowerCase().includes(search)
          );
        }
        return NotZero;
        /*if(this.searchBy == 'ALL'){
					return NotZero
				}else if(this.searchBy == 'favorites'){
					return NotZero.filter(val => this.fev_list.includes(val.symbol) )
				}else{
					return NotZero.filter(val => val.symbol == this.searchBy )
				}*/
      } else {
        if (this.searchCurrency != "") {
          let search = this.searchCurrency.toLowerCase();
          returnData = returnData.filter(
            (val) =>
              val.symbol.toLowerCase().includes(search) ||
              val.currency_name.toLowerCase().includes(search)
          );
        }
        return returnData;
        /*if(this.searchBy == 'ALL'){
					return returnData
				}else if(this.searchBy == 'favorites'){
					return returnData.filter(val => this.fev_list.includes(val.symbol) )
				}else{
					return returnData.filter(val => val.symbol == this.searchBy )
				}*/
      }
    },
  },
  methods: {
    getROI(wallet) {
      if (wallet && wallet.holdingPrice) {
        let currencyDetail = Object.values(this.$env_var.walletCurrencyList);
        let list = currencyDetail.find((i) => i.symbol == wallet.currency);
        if (!list || (list && list.keyType != "FIAT")) {
          let initialValue = wallet.holdingPrice * wallet.freemargin;
          let currentValue = 0;
          if (this.instruments[`${wallet.currency}-USD`]) {
            currentValue = this.instruments[`${wallet.currency}-USD`].A;
          } else if (this.instruments[`${wallet.currency}-USDT`]) {
            currentValue = this.instruments[`${wallet.currency}-USDT`].A;
          } else if (this.instruments[`USDT-${wallet.currency}`]) {
            currentValue = 1 / this.instruments[`${wallet.currency}-USDT`].A;
          } else if (
            this.instruments[`${wallet.currency}-BTC`] &&
            this.instruments[`BTC-USD`]
          ) {
            currentValue =
              this.instruments[`${wallet.currency}-BTC`].A /
              this.instruments[`BTC-USD`].A;
          } else if (
            this.instruments[`BTC-${wallet.currency}`] &&
            this.instruments[`BTC-USD`]
          ) {
            currentValue =
              1 /
              this.instruments[`BTC-${wallet.currency}`].A /
              this.instruments[`BTC-USD`].A;
          }

          currentValue = currentValue * wallet.freemargin;
          return ((currentValue - initialValue) / initialValue) * 100;
        }
      }
      return 0;
    },
    ExchangeEnableDisable(getCurrency) {
      let currency = getCurrency.split("-");
      let JsonData = { 0: "", 1: "" };
      for (let i = 0; i <= currency.length - 1; i++) {
        let sendReceive = 0,
          count = 0;
        for (let key in this.margin_list) {
          count++;
          if (
            this.margin_list[key].currency
              .toLowerCase()
              .includes(currency[i].toLowerCase())
          ) {
            sendReceive = 1;
          }
          if (
            count == Object.keys(this.margin_list).length &&
            sendReceive == 1 &&
            JsonData[0] == ""
          ) {
            JsonData[0] = currency[i];
          } else if (count == Object.keys(this.margin_list).length) {
            JsonData[1] = currency[i];
          }
        }
        if (i == currency.length - 1) {
          if (JsonData[0] != "") {
            return true;
          } else {
            return false;
          }
        }
      }
    },
    formatfloat(num) {
      if (num) {
        num = parseFloat(num);
        try {
          return math.format(num, { notation: "fixed" }) || "";
        } catch (e) {
          try {
            return num.toFixed(8);
          } catch (e) {
            return "";
          }
        }
      } else {
        return 0;
      }
    },
    closeWithdrawal() {
      this.withdrawalItem = {};
    },
    searchByFunc(val) {
      if (val != this.searchBy) {
        this.searchBy = val;
        this.page = "1";
        this.searchCurrency = "";
      }
    },
    addRemoveFev(currency) {
      if (this.fev_list.includes(currency)) {
        this.fev_list = this.fev_list.filter((item) => item !== currency);
      } else {
        this.fev_list.push(currency);
      }
      this._addfavoriteCurrencyList({
        globalParams: {
          currencies: this.fev_list,
        },
        localParams: { parameter: this },
      });
    },
    isImage(img) {
      return this.errImage.includes(img) ? false : true;
    },
    handleImgErr(val) {
      let fullSrc = val.target.src.split(".");
      let src = fullSrc[fullSrc.length - 2].split("/");
      let img = src[src.length - 1];
      if (!this.errImage.includes(img)) {
        this.errImage.push(img);
      }
    },
    getCurrency(value) {
      if (value.length > 0 && value[0].subAccounts.length > 0) {
        /*this.currency = value[0].subAccounts[0]
				let btcPair = value[0].subAccounts.map(val=>val.currency + '-BTC')
				let usdPair = value[0].subAccounts.map(val=>val.currency + '-USD')
				this.subscribPairs(btcPair.concat(usdPair))*/
        this._runGetMarginInfo({
          globalParams: { account_id: value[0].account_id },
          localParams: { parameter: this, page: "wallet" },
        });
      }
    },
    subscribPairs(pairList) {
      /*try{
				if(pairList.length > 0){
					this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
					.seeders['S_PF_PF'].subscribe(pairList)
				}
			}catch(e){
				setTimeout(() => {
					this.subscribPairs(pairList)
	            }, 1000);
			}*/
    },
    changeCurencyUsdValList() {
      this.currencyData();
      setTimeout(() => {
        this.currencyData();
      }, 5000);
    },
    currencyData() {
      try {
        this.curencyUsdValList = [];
        for (const item in this.margin_list) {
          let index = this.curencyUsdValList
            .map((e) => e.currency)
            .indexOf(this.margin_list[item].currency);
          if (parseFloat(this.margin_list[item].amount)) {
            if (index == -1) {
              this.curencyUsdValList.push({
                currency: this.margin_list[item].currency,
                usdValue: this.getConvertedValue(this.margin_list[item], "USD"),
              });
            } else {
              this.curencyUsdValList[index]["usdValue"] =
                this.getConvertedValue(this.margin_list[item], "USD");
            }
          }
        }
        this.curencyUsdValList.sort(function (a, b) {
          return parseFloat(b.usdValue) - parseFloat(a.usdValue);
        });
        this.page = "1";
      } catch (e) {
        setTimeout(() => {
          this.currencyData();
        }, 1000);
      }
    },
    getConvertedValue(item, currency) {
        console.log(item)
        console.log(currency)
      if (item.currency == currency) {
        return item.amount;
      } else {
        let amount = 0;
        if (this.instruments[item.currency + "-" + currency]) {
          amount = this.instruments[item.currency + "-" + currency].A;
        } else if (this.instruments[currency + "-" + item.currency]) {
          amount = 1 / this.instruments[currency + "-" + item.currency].A;
        } else {
          let basePrice = null,
            reversebasePrice = null,
            pairValue = null,
            revpairValue = null;
          if (currency == "USD") {
            basePrice = this.instruments[item.currency + "-BTC"];
            reversebasePrice = this.instruments["BTC-" + item.currency];
            pairValue = this.instruments["BTC-" + currency];
          } else {
            basePrice = this.instruments[item.currency + "-USD"];
            reversebasePrice = this.instruments["USD-" + item.currency];
            pairValue = this.instruments["USD-" + currency];
          }
          if (basePrice && pairValue) {
            amount = pairValue.A * basePrice.A;
          } else if (reversebasePrice && pairValue) {
            amount = pairValue.A / reversebasePrice.A;
          } else {
            amount = 0;
          }
        }
        if (currency == "USD") {
          return (amount * item.amount).toFixed(3);
          // return (amount * item.amount).toFixed(3)
        } else {
          return this.formatfloat(amount * item.amount);
        }
      }
    },
  },
  created() {
    this._runGetWithDepoCurList({
      globalParams: {},
      localParams: { parameter: this, 'link':true },
    });
    this.pageName("Wallets");
    let _that = this;
    if (parseInt(this.accountSelected) == 1) {
      this.getCurrency(this.socialAccount);
    } else {
      this.getCurrency(this.tradingAccount);
    }
    // this._runTradingAccount({ 'globalParams' :{ },'localParams' :{"parameter" : this}})
    //this._runGetWithdrawalMethods({'globalParams' :{},'localParams' :{"parameter" : this } })
    this._getfavoriteCurrencyList({
      globalParams: {},
      localParams: { parameter: this },
    });
    setTimeout(function () {
      if (_that.$route.query.currency) {
        // console.log('query------->',_that.$route.query.currency)
        let currency = _that.$route.query.currency;
        _that.deposit_currency = currency;
        _that.$router.replace({ query: "" });
      }
    }, 1000);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/wallet/wallets.vue